import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import ChangeTimePlaceDay from '../ChangeTimePlaceDay';
import { calculateHandoverDays, applyChanges } from './ChangeTimePlaceCalc';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import { IHandoverSetting, getDefaultDays } from '../ScheduleCalc';
import { IFamilyMember } from '@app-types/websocket/family.types';
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";

const tn: TranslateNew = TranslateNew.getInstance();



interface IState {
  parentATakesOver:IHandoverSetting[];
  parentBTakesOver:IHandoverSetting[];

  parentATakesOverOnDays:number[];
  parentBTakesOverOnDays:number[];
}

interface IProps extends WithStyles<typeof EditActionStyle> {
  family:IFamilyMember[];
  userId:number;
  selectedDays:IDateRange[];
  scheduleEditBase:ISchedule|undefined; 
  updatePreview:(schedule:ISchedule) => void;
  updateBase:(schedule:ISchedule) => void;
  close:(finished:boolean) => void;
}

class ChangeTimePlace extends React.Component<IProps, IState> {

  private timer = setTimeout(() => {return;}, 100);

  constructor(props: IProps) {
    super(props);
    
    const handovers = calculateHandoverDays(props.selectedDays, props.scheduleEditBase);
    const timePlace = getDefaultDays(props.scheduleEditBase);
    
    this.state = {
      parentATakesOver: timePlace.parentATakesOver,
      parentBTakesOver: timePlace.parentBTakesOver,
      parentATakesOverOnDays:handovers.parentApickupDays,
      parentBTakesOverOnDays:handovers.parentBpickupDays,
    };

    if (props.scheduleEditBase !== undefined) {
      props.updatePreview(applyChanges(props.scheduleEditBase, props.selectedDays, 
        this.state.parentATakesOver, this.state.parentBTakesOver,0));
    }
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.selectedDays !== this.props.selectedDays ) {
      const handovers = calculateHandoverDays(this.props.selectedDays, this.props.scheduleEditBase);
      if (this.props.scheduleEditBase !== undefined) {
        this.props.updatePreview(applyChanges(this.props.scheduleEditBase, this.props.selectedDays, 
          this.state.parentATakesOver, this.state.parentBTakesOver,0));
      }
      this.setState({parentATakesOverOnDays:handovers.parentApickupDays, parentBTakesOverOnDays:handovers.parentBpickupDays});
    }
  }

  public render() {
    const {classes, family} = this.props;

    const pADays:JSX.Element[] = [];
    const pBDays:JSX.Element[] = [];


    let pA:number|undefined;
    let pB:number|undefined;

    if (this.props.scheduleEditBase) {
      pA = this.props.scheduleEditBase.data.parentA;
      pB = this.props.scheduleEditBase.data.parentB;
    }

    const school = this.props.scheduleEditBase?this.props.scheduleEditBase.school:undefined;
    const schoolAge = schoolAgeFromFamily(family);

    let totalChanges = 0;
    for (let index = 0; index < this.state.parentATakesOverOnDays.length; index++) {
      const occurences = this.state.parentATakesOverOnDays[index];
      totalChanges += occurences;
      if (occurences > 0) {
        pADays.push(<ChangeTimePlaceDay 
          key={"pickup"+index}
          title={tn.lang.getWeekdayName(index)}
          occurences={occurences}
          atSchool={this.state.parentATakesOver[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={this.state.parentATakesOver[index].location}
          hour={this.state.parentATakesOver[index].hour}
          minute={this.state.parentATakesOver[index].minute}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.update("parentA", index, {atSchool,location:loc,hour,minute}, direct)}
        />)
      }
    }

    for (let index = 0; index < this.state.parentBTakesOverOnDays.length; index++) {
      const occurences = this.state.parentBTakesOverOnDays[index];
      totalChanges += occurences;
      if (occurences > 0) {
        pBDays.push(<ChangeTimePlaceDay
          key={"dropoff"+index}
          title={tn.lang.getWeekdayName(index)}
          occurences={occurences}
          atSchool={this.state.parentBTakesOver[index].atSchool}
          school={school}
          schoolAge={schoolAge}
          loc={this.state.parentBTakesOver[index].location}
          hour={this.state.parentBTakesOver[index].hour}
          minute={this.state.parentBTakesOver[index].minute}
          update={(atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => 
            this.update("parentB", index, {atSchool,location:loc,hour,minute}, direct)}
        />)
      }
    }

    let helperText:JSX.Element|null = null;

    if (pADays.length === 0 || pBDays.length === 0) {
      helperText = tn.lang.calTimePlaceHelp;
    }

    return (<>
      <div className={classes.paneOptions} >
        <Button className={classes.paneOption} startIcon={<BackArrowIcon />} classes={{text:classes.backButton}} 
          style={{textAlign: 'start'}} onClick={() => {
            if (this.props.scheduleEditBase) {
              this.props.updatePreview(this.props.scheduleEditBase);  
            }
            this.props.close(false);
          }}>
          {tn.lang.back}
        </Button>
        <div className={classes.paneOption} style={{minHeight:'20px', fontSize:'12px'}}>{""}</div>
        <Button className={classes.paneOption} variant="contained" color="primary" style={{textAlign: 'end', marginRight:'10px'}} 
          disabled={totalChanges === 0} onClick={() => this.execute()} classes={{contained:classes.buttonContained}} >
          {tn.lang.save}
        </Button>
      </div>
      <div className={classes.pane}>
        {helperText}
        <div className={classes.handoverDayDetails} style={pADays.length>0?{}:{display:'none'}}>
          <span style={{fontSize:'11px'}}>{tn.lang.calWhenExchange}</span>
          <span className={classes.handoverGroupTitle}>
            {tn.lang.calHandoverToFrom(tn.familyMemberName(pB,family), tn.familyMemberName(pA,family))}
          </span>
        </div>
        {pADays}
        <div className={classes.handoverDayDetails} style={pBDays.length>0?{}:{display:'none'}}>
          <span style={{fontSize:'11px',marginTop: '20px'}}>{tn.lang.calWhenExchange}</span>
          <span className={classes.handoverGroupTitle}>
            {tn.lang.calHandoverToFrom(tn.familyMemberName(pA,family), tn.familyMemberName(pB,family))}
          </span>
        </div>
        {pBDays}
      </div>
      </>
    );
  }

  private execute() {
    if (this.props.scheduleEditBase) {
      this.props.updateBase(applyChanges(this.props.scheduleEditBase, this.props.selectedDays, 
        this.state.parentATakesOver, this.state.parentBTakesOver,0));
      this.props.close(true);
    }
  }

  private update(side:"parentA"|"parentB", index:number, settings:IHandoverSetting, direct:boolean) {
    if (side === "parentA") {
      const parentATakesOver = [...this.state.parentATakesOver];
      parentATakesOver[index] = settings;
      this.setState({parentATakesOver});
      if (this.props.scheduleEditBase) {
        this.updatePreview(direct, this.props.scheduleEditBase, this.props.selectedDays, 
          parentATakesOver, this.state.parentBTakesOver,0);
      }
    } else {
      const parentBTakesOver = [...this.state.parentBTakesOver];
      parentBTakesOver[index] = settings;
      this.setState({parentBTakesOver});
      if (this.props.scheduleEditBase) {
        this.updatePreview(direct, this.props.scheduleEditBase, this.props.selectedDays, 
          this.state.parentATakesOver, parentBTakesOver,0);
      }
    } 
  }

  private updatePreview(direct:boolean, schedule:ISchedule, selectedDays:IDateRange[], 
    aPickup:IHandoverSetting[], bPickup:IHandoverSetting[], time:number) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() =>
      this.props.updatePreview(applyChanges(schedule, selectedDays, aPickup, bPickup, time))
      ,direct?0:500);
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family:state.family.family,
  };
}

export default connect(mapStateToProps)(withStyles(EditActionStyle)(ChangeTimePlace));



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/ChangeTimePlace/ChangeTimePlace.tsx